export const stickyHeaderStyle = () => {
  var isSafari;
  let vendor = navigator.vendor;
  if (vendor === 'Apple Computer, Inc.') {
    isSafari = true;
  } else {
    isSafari = false;
  }
  var stickyHeaderStyle;

  stickyHeaderStyle = {
    position: isSafari === true ? '-webkit-sticky' : 'sticky',
    top: '0px',
    width: '100%',
    zIndex: 999999999
  };

  return stickyHeaderStyle;
};

export const stickyFooterStyle = () => {
  var isSafari;
  let vendor = navigator.vendor;
  if (vendor === 'Apple Computer, Inc.') {
    isSafari = true;
  } else {
    isSafari = false;
  }
  let stickyFooterStyle;

  stickyFooterStyle = {
    position: isSafari === true ? '-webkit-sticky' : 'sticky',
    bottom: '0px',
    width: '100%',
    zIndex: 999999999
  };

  return stickyFooterStyle;
};
